import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './MembersNavbar.css';

const MembersNavbar = () => {
  const { member, logout } = useAuth();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
  };

  const navLinks = [
    { path: '/members/dashboard', label: 'Tableau de bord' },
    { path: '/members/editions', label: 'Éditions' },
    { path: '/members/directory', label: 'Annuaire' },
  ];

  return (
    <nav className="members-navbar">
      <div className="navbar-container">
        <Link to="/members/dashboard" className="navbar-logo">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="18" fill="white" stroke="#1f5d5b" strokeWidth="2" />
            <text x="20" y="26" textAnchor="middle" fill="#1f5d5b" fontSize="16" fontWeight="bold" fontFamily="'Lucidity Condensed', cursive">T</text>
          </svg>
        </Link>

        <button
          className="mobile-hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.path} className="nav-item">
              <Link
                to={link.path}
                className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar-right">
          {member && (
            <>
              <span className="member-name">{member.name}</span>
              <button className="logout-button" onClick={handleLogout}>
                Déconnexion
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default MembersNavbar;
